export default "__VITE_ASSET__DWm93Ee5__"